import apiV2 from "api-v2";
import type { AxiosResponse } from "axios";
import type { ApiResponse } from "types/common.types";
import type { RfxProjectType } from "../types/rfx.types";

export const getProjectTypes = (): Promise<
	AxiosResponse<ApiResponse<RfxProjectType[]>>
> => {
	return apiV2.get<ApiResponse<RfxProjectType[]>>("project-types");
};
